module.exports = __webpack_public_path__ + "img/elementwidths_jaka.c2cbc97e.png";